import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { usePanelState } from "../../../../../stores/hooks/usePanelState";
import { Checkbox } from "../../../../../ui/Checkbox/Checkbox";
import { Collapsible } from "../../../../../ui/CollapsiblePannel/Collapsible";
import { useTireBrandOptions } from "./useTireBrandOptions";
import { useTireBrands } from "./useTireBrands";

const id = "dealer-tire-brands-panel";

export const TireBrandFilters: FunctionComponent = () => {
  const [panelIsOpen, togglePanel] = usePanelState(id, false);
  const { t } = useTranslation();
  const options = useTireBrandOptions();
  const [, { toggle }] = useTireBrands();
  return (
    <Collapsible
      className=" space-y-2"
      id={id}
      label={t("searchResults.tireBrand")}
      onToggle={togglePanel}
      visible={panelIsOpen}
    >
      {options.map(({ brand, checked, count }) => (
        <label
          className={clsx("flex gap-x-4", !count && "opacity-40")}
          key={brand}
        >
          <Checkbox
            onChange={(): void => {
              toggle([brand]);
            }}
            checked={checked}
            checkedClassName="text-selected-tab"
            disabled={count === 0}
            name="brand"
          />
          <span className="flex-1">{brand}</span>
        </label>
      ))}
    </Collapsible>
  );
};
